import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../../app/guards'
import { returnQueryOptions } from '../../../../features/pos/queries'
import { PosReturnPage } from '../../../../features/pos/return-page'

/** A till return and its RETURN copy (reprint), for whoever may open till returns. */
export const Route = createFileRoute('/_app/pos/returns/$returnId')({
  staticData: { crumb: 'posReturn' },
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'pos.sell', 'pos.view_shift', 'pos.return', 'pos.return_unlinked'),
  loader: ({ context, params }) => context.queryClient.ensureQueryData(returnQueryOptions(params.returnId)),
  component: PosReturnPage,
})
